<template>
  <a-modal
    :title="title"
    :width="1200"
    :visible="modalMisible"
    :plain="true"
    @ok="submitOk"
    @cancel="modalMisible=false"
  >
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="订单号">
                <a-input placeholder="请输入订单号" ></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="状态">
                <a-select  placeholder="请选择">
                  <a-select-option value=" ">请选择</a-select-option>
                  <a-select-option value="0">订单未结算</a-select-option>
                  <a-select-option value="1">已结算</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="关联业务">
                <a-select  placeholder="请选择">
                  <a-select-option value=" ">请选择</a-select-option>
                  <a-select-option value="0">订单未结算</a-select-option>
                  <a-select-option value="1">已结算</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">
        <a-button type="primary" icon="download" >导出</a-button>
        <a-dropdown >
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
        </a-dropdown>
      </div>
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">11</a>项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>

      </div>

    </a-card>

  </a-modal>
</template>

<script>
  export default {
    name: 'DaccountIndexModal',

    data() {
      return {
        title: '医生账单详情',
        modalMisible: false,

        columns: [
          {
            title:'医生ID',
            align:"center",
            dataIndex: 'doctorId'
          },
          {
            title:'医生姓名',
            align:"center",
            dataIndex: 'name'
          },
          {
            title:'累计收入（元）',
            align:"center",
            dataIndex: 'totalAmount'
          },
          {
            title:'账户余额',
            align:"center",
            dataIndex: 'balance'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],


        form: this.$form.createForm(this),
        validatorRules: {
          share: {
            rules: [
              { required: true, message: '请输入数字值'},
            ]
          },

        },


        url: {
          list: "/daccount/doctorAccount/list",
        },
      }
    },
    created() {
      this.open();
    },
    methods: {
      open(record) {
        let attr = {};
        attr.id = record.id;

        this.modalMisible = true
      },
      submitOk(){
        this.modalMisible = false
      }


    }



  }
</script>

<style scoped>
  /*@import '~@assets/less/common.less';*/
</style>